import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "../../api/axios";

import './LoginSignup.css';
const VerifyEmail = () => {
  const location = useLocation();

  const [email, setEmail] = useState(location.state?.email || "");
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isVerifyingLink, setIsVerifyingLink] = useState(false);
  const [verificationComplete, setVerificationComplete] = useState(false);

  const linkCode = new URLSearchParams(window.location.search).get("code");

  const code = otpDigits.join(""); // Combine digits for submission

  useEffect(() => {
    if (linkCode) {
      setIsVerifyingLink(true);
      setError("");
      setMessage("");

      axios.post("/api/auth/verify-email-link", { linkCode })
        .then(() => {
          setMessage("✅ Your email has been successfully verified! Redirecting...");
          setTimeout(() => {
            window.location.href = "/user/profile";
          }, 3000);
        })
        .catch(err => {
          setError(err.response?.data?.error || "Invalid or expired verification link.");
        })
        .finally(() => {
          setIsVerifyingLink(false);
          setVerificationComplete(true);
        });
    }
  }, [linkCode]);

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Only digits, 1 character max
    const updatedDigits = [...otpDigits];
    updatedDigits[index] = value;
    setOtpDigits(updatedDigits);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);

    if (pasteData.length === 6) {
      const updatedDigits = pasteData.split('');
      setOtpDigits(updatedDigits);
      document.getElementById('otp-5').focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      const updatedDigits = [...otpDigits];
      updatedDigits[index - 1] = "";
      setOtpDigits(updatedDigits);
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      await axios.post("/api/auth/verify-email-code", { email, code });
      setMessage("✅ Email verified successfully! Redirecting...");
      setTimeout(() => {
        window.location.href = "/user/profile";
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.error || "Invalid verification code.");
    }
  };

  return (
    <>




      <div className="auth-page-wrapper">
  <div className="auth-container">
    <h2>Verify Your Email</h2>
    <p>Already verified? <Link to="/login">Login</Link></p>

    {/* ✅ Link Verification Flow */}
    {linkCode ? (
      <>
        <p aria-live="polite">
          {isVerifyingLink ? "Verifying your email..." : ""}
        </p>
        {!isVerifyingLink && verificationComplete && (
          <>
            {message ? (
              <p className="success" role="alert">{message}</p>
            ) : error ? (
              <p className="error" role="alert">{error}</p>
            ) : null}
          </>
        )}
      </>
    ) : (
      <>
        {/* ✅ Status Messages */}
        {message ? (
          <p className="success" role="alert">{message}</p>
        ) : error ? (
          <p className="error" role="alert">{error}</p>
        ) : null}

        {/* ✅ Missing Email Case */}
        {!email ? (
          <p className="error" role="alert">
            Missing email for verification. Please check your registration flow.
          </p>
        ) : (
          <>
            <p>If you have a 6-digit verification code, enter it below:</p>

            {/* ✅ Verification Form */}
            <form onSubmit={handleSubmit}>
              <label htmlFor="verify-email" className="sr-only">Email</label>
              <input
                id="verify-email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled
                readOnly
              />

              {/* ✅ OTP Input with Accessibility Enhancements */}
              <div className="otp-container" onPaste={handleOtpPaste}>
                {otpDigits.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    className="otp-box"
                    aria-label={`Digit ${index + 1} of 6 for verification`}
                  />
                ))}
              </div>

              <button
                type="submit"
                disabled={code.length !== 6}
                aria-live="polite"
              >
                Verify Email
              </button>
            </form>
          </>
        )}
      </>
    )}
  </div>
</div>

    </>
  );
};

export default VerifyEmail;